import { ElectedInfo } from "../../../../src/components/electeds/elected-info.js";
import Stefani from "../../../../content/people/catherine-stefani/stefani.js";
import * as React from 'react';
export default {
  ElectedInfo,
  Stefani,
  React
};